import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79847082"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page skills" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title mb-24" }, "Skills")
], -1))
const _hoisted_3 = { class: "technical-skills" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = ["textContent", "onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-chevron-down"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "skill-showcase"
}
const _hoisted_9 = ["src", "alt", "data-skill"]
const _hoisted_10 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TechnicalSkills, (skillCategory, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "tech-skill"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", {
              class: "skill-cat-title",
              textContent: _toDisplayString(skillCategory.name),
              onClick: ($event: any) => (_ctx.showCategory(skillCategory.name))
            }, null, 8, _hoisted_5),
            _createElementVNode("div", {
              class: _normalizeClass(["accordion-icon", _ctx.showingCategory == skillCategory.name ? 'rotate-180 transform-gpu': 'animate-bounce'])
            }, _hoisted_7, 2)
          ]),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              (_ctx.showingCategory == skillCategory.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skillCategory.skills, (skill, index) => {
                      return (_openBlock(), _createElementBlock("span", { key: index }, [
                        _createElementVNode("img", {
                          class: "mx-auto",
                          src: skill.icon,
                          alt: skill.name,
                          "data-skill": skill.name,
                          width: "30",
                          height: "30"
                        }, null, 8, _hoisted_9),
                        _createElementVNode("span", {
                          class: "skill-title",
                          textContent: _toDisplayString(skill.name)
                        }, null, 8, _hoisted_10)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ])
  ]))
}